(function() {
  const grid = document.querySelector(".js-quests-hero-grid");
  if (!grid) return;

  let tiles = [];
  let resizeTimeout;

  function clearTiles() {
    tiles.forEach(tile => tile.remove());
    tiles = [];
  }

  function createTiles() {
    const gridWidth = grid.offsetWidth;
    const gridHeight = grid.offsetHeight;
    const tileSize = 64;
    const gap = 1;

    const tilesPerRow = Math.ceil(gridWidth / (tileSize + gap));
    const tilesPerColumn = Math.ceil(gridHeight / (tileSize + gap));
    const totalTiles = tilesPerRow * tilesPerColumn;

    // Set explicit grid columns and rows to allow partial tiles
    grid.style.gridTemplateColumns = `repeat(${tilesPerRow}, ${tileSize}px)`;
    grid.style.gridTemplateRows = `repeat(${tilesPerColumn}, ${tileSize}px)`;

    for (let i = 0; i < totalTiles; i++) {
      const tile = document.createElement("div");
      tile.className = "quests-hero-tile";
      grid.appendChild(tile);
      tiles.push(tile);
    }
  }

  function highlightRandomTiles() {
    tiles.forEach(tile => tile.classList.remove("highlighted"));

    const numToHighlight = Math.floor(tiles.length * 0.085);
    const highlightedIndices = new Set();

    while (highlightedIndices.size < numToHighlight) {
      const randomIndex = Math.floor(Math.random() * tiles.length);
      highlightedIndices.add(randomIndex);
    }

    highlightedIndices.forEach(index => {
      tiles[index].classList.add("highlighted");
    });
  }

  function initGrid() {
    clearTiles();
    createTiles();
    highlightRandomTiles();
  }

  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initGrid();
    }, 150);
  }

  createTiles();

  setTimeout(() => {
    grid.classList.add("active");
    highlightRandomTiles();
  }, 500);

  window.addEventListener("resize", handleResize);
})();
